<template>
    <v-container>
        <loader v-if="isloading"></loader>
        <v-card shaped class="mx-md-4 my-md-4 pa-4">
            <v-toolbar flat color="#1d2735" dark style="border-radius: 5px">
                <v-icon class="white--text" style="font-size: 45px"
                    >mdi-account-supervisor-circle</v-icon
                >
                <pre
                    v-if="pedido.id"
                ><v-toolbar-title><h2>Editar pedido: {{ pedido.id }}</h2></v-toolbar-title></pre>
                <pre
                    v-else
                ><v-toolbar-title><h2>Crear pedido</h2></v-toolbar-title></pre>
            </v-toolbar>
            <v-tabs :scrollable="false" v-model="tab">
                <v-tab>Datos</v-tab>
                <v-tab v-if="pedido.id != null">Archivos</v-tab>
                <v-row justify="end">
                    <v-tooltip right style="margin-bottom: 5px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                fab
                                :to="'lista-pedido-proveedor'"
                                :loading="isloading"
                                :disabled="isloading"
                                color="blue"
                                class="mt-4 mx-3"
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon class="white--text"
                                    >mdi-arrow-left-bold-outline</v-icon
                                >
                            </v-btn>
                        </template>
                        <span>Volver</span>
                    </v-tooltip>
                </v-row>
                <v-tab-item>
                    <v-row>
                        <v-col cols="12">
                            <v-form class="mt-3" ref="pedido">
                                <v-card style="min-width: 100%; padding: 1rem">
                                    <h3>Datos del pedido</h3>
                                    <v-row>
                                        <v-col cols="12" md="4">
                                            <proveedoresSelectVue
                                                label="Proveedor"
                                                v-model="pedido.id_proveedor"
                                                item-text="nombre"
                                                item-value="id"
                                                :extra="pedido.proveedor"
                                            >
                                            </proveedoresSelectVue>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <ordenesSelect
                                                v-model="pedido.id_orden"
                                                label="Obra"
                                                :extra="[pedido.orden]"
                                                :rules="required_val"
                                                :multiple="false"
                                            >
                                            </ordenesSelect>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <date-select
                                                label="Fecha pedido"
                                                v-model="pedido.fecha_pedido"
                                            >
                                            </date-select>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <date-select
                                                label="Fecha prevista"
                                                v-model="pedido.fecha_prevista"
                                            >
                                            </date-select>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <date-select
                                                label="Fecha real"
                                                v-model="pedido.fecha_real"
                                            >
                                            </date-select>
                                        </v-col>
                                    </v-row>
                                </v-card>
                                <v-card style="min-width: 100%; padding: 1rem">
                                    <h3>Nueva línea de pedido</h3>
                                    <v-row>
                                        <v-col cols="12" md="2">
                                            <ProductosCompraSelect
                                                v-model="
                                                    linea.id_producto_compra
                                                "
                                                :items="productos_compra"
                                                item-text="nombre"
                                                item-value="id"
                                                label="Producto asociado"
                                            >
                                            </ProductosCompraSelect>
                                            <!--<dynamic-select
                                            outlined
                                            title="Codigo"
                                            v-bind:estados="codigos"
                                            show="nombre"
                                            v-model="linea.codigo"
                                            @create="saveCodigo"
                                            @delete="deleteCodigo"
                                            @getItem="
                                                (val) => {
                                                    codigo = val;
                                                }
                                            "
                                            @update="saveCodigo"
                                        >
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-text-field
                                                        label="Codigo"
                                                        v-model="codigo.nombre"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </dynamic-select>-->
                                        </v-col>
                                        <v-col cols="12" md="5">
                                            <div class="spacing">
                                                <v-text-field
                                                    v-model="linea.descripcion"
                                                    label="Descripción"
                                                >
                                                </v-text-field>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="1">
                                            <div class="spacing">
                                                <v-text-field-comma
                                                    outlined
                                                    v-model="linea.cantidad"
                                                    type="number"
                                                    label="Cantidad"
                                                >
                                                </v-text-field-comma>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="1">
                                            <div class="spacing">
                                                <v-text-field-comma
                                                    outlined
                                                    v-model="linea.precio"
                                                    type="number"
                                                    label="Precio unitario"
                                                >
                                                </v-text-field-comma>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="2">
                                            <div style="display: flex">
                                                <v-text-field-comma
                                                    v-if="linea.tipo_dcto == 1"
                                                    outlined
                                                    v-model="linea.dcto"
                                                    type="number"
                                                    label="Descuento"
                                                >
                                                </v-text-field-comma>
                                                <v-text-field-comma
                                                    v-else
                                                    outlined
                                                    v-model="linea.dcto_per"
                                                    type="number"
                                                    label="Descuento"
                                                >
                                                </v-text-field-comma>
                                                <v-btn-toggle
                                                    color="primary"
                                                    shaped
                                                    v-model="linea.tipo_dcto"
                                                    background-color="white"
                                                >
                                                    <v-btn text>
                                                        <v-icon
                                                            >mdi-percent</v-icon
                                                        >
                                                    </v-btn>
                                                    <v-btn text>
                                                        <v-icon
                                                            >mdi-currency-eur</v-icon
                                                        >
                                                    </v-btn>
                                                </v-btn-toggle>
                                            </div>
                                        </v-col>
                                        <v-col cols="12" md="1">
                                            <v-btn
                                                @click="addLinea"
                                                :disabled="isloading"
                                                color="success"
                                                class="white--text"
                                                >Añadir</v-btn
                                            >
                                        </v-col>
                                    </v-row>
                                </v-card>
                                <v-card style="min-width: 100%; padding: 1rem">
                                    <h3>Líneas del pedido</h3>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-data-table
                                                dense
                                                :headers="headers"
                                                hide-default-footer
                                                :items="pedido.lineas"
                                                item-key="id"
                                                class="elevation-1"
                                            >
                                                <template
                                                    v-slot:item.cantidad="{
                                                        item,
                                                    }"
                                                >
                                                    {{
                                                        item.cantidad
                                                            | decimalComma
                                                    }}
                                                </template>
                                                <template
                                                    v-slot:item.precio="{
                                                        item,
                                                    }"
                                                >
                                                    {{
                                                        item.precio
                                                            | format_precio
                                                    }}
                                                </template>

                                                <template
                                                    v-slot:item.subtotal="{
                                                        item,
                                                    }"
                                                >
                                                    {{
                                                        (item.precio *
                                                            item.cantidad)
                                                            | format_precio
                                                    }}
                                                </template>
                                                <template
                                                    v-slot:item.total="{ item }"
                                                >
                                                    {{
                                                        item.total
                                                            | format_precio
                                                    }}
                                                </template>
                                                <template
                                                    v-slot:item.dcto="{ item }"
                                                >
                                                    {{
                                                        item.dcto
                                                            | format_precio
                                                    }}
                                                </template>
                                                <template
                                                    v-slot:item.action="{
                                                        item,
                                                    }"
                                                >
                                                    <v-icon
                                                        @click="
                                                            openEditDialog(item)
                                                        "
                                                        small
                                                        class="mr-2"
                                                        color="black"
                                                        style="font-size: 25px"
                                                        title="EDITAR"
                                                        >mdi-pencil-outline</v-icon
                                                    >

                                                    <v-icon
                                                        @click="
                                                            openDeleteDialog(
                                                                item
                                                            )
                                                        "
                                                        small
                                                        class="mr-2"
                                                        color="red"
                                                        style="font-size: 25px"
                                                        title="BORRAR"
                                                        >mdi-trash-can</v-icon
                                                    >
                                                </template>
                                            </v-data-table>
                                        </v-col>
                                    </v-row>

                                    <v-row align="start" justify="end">
                                        <v-col cols="8"> </v-col>
                                        <v-col cols="12" md="4">
                                            <v-card
                                                style="
                                                    min-width: 100%;
                                                    padding: 1rem;
                                                "
                                            >
                                                <v-row>
                                                    <v-col cols="6">
                                                        <h4>Subtotal:</h4>
                                                    </v-col>
                                                    <v-col cols="6">
                                                        <h4>
                                                            {{
                                                                formatNumber(
                                                                    total
                                                                )
                                                            }}
                                                            €
                                                        </h4>
                                                    </v-col>
                                                    <v-col cols="6">
                                                        <h4>IVA:</h4>
                                                    </v-col>
                                                    <v-col cols="6">
                                                        <h4>
                                                            {{
                                                                formatNumber(
                                                                    total * 0.21
                                                                )
                                                            }}
                                                            €
                                                        </h4>
                                                    </v-col>
                                                    <v-col cols="6">
                                                        <h4>Total:</h4>
                                                    </v-col>
                                                    <v-col cols="6">
                                                        <h4>
                                                            {{
                                                                formatNumber(
                                                                    total * 1.21
                                                                )
                                                            }}
                                                            €
                                                        </h4>
                                                    </v-col>
                                                </v-row>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-textarea
                                                label="Observaciones"
                                                v-model="pedido.observaciones"
                                                outlined
                                            >
                                            </v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-card>
                                <v-row style="margin-top: 10px">
                                    <v-col cols="12">
                                        <router-link
                                            to="lista-pedido-proveedor"
                                        >
                                            <v-btn
                                                color="red"
                                                class="white--text mr-2"
                                            >
                                                Volver
                                            </v-btn>
                                        </router-link>
                                        <v-btn
                                            v-if="!pedido.id"
                                            @click="savePedido"
                                            :disabled="isloading"
                                            color="success"
                                            class="white--text mr-2"
                                            >Guardar</v-btn
                                        >
                                        <template v-if="pedido.id">
                                            <v-btn
                                                @click="email_dialog = true"
                                                :disabled="isloading"
                                                color="primary"
                                                class="white--text mr-2"
                                                >Enviar email</v-btn
                                            >
                                            <v-btn
                                                @click="recepcionar = true"
                                                :disabled="isloading"
                                                color="primary"
                                                class="white--text mr-2"
                                            >
                                                <template
                                                    v-if="
                                                        this.pedido
                                                            .fecha_real != null
                                                    "
                                                >
                                                    Recepcionar
                                                </template>
                                                <template v-else>
                                                    Estado a pedido
                                                </template></v-btn
                                            >

                                            <v-btn
                                                @click="
                                                    duplicar = true;
                                                    savePedido();
                                                "
                                                :disabled="isloading"
                                                color="primary"
                                                class="white--text mr-2"
                                                >Duplicar</v-btn
                                            >

                                            <v-btn
                                                v-if="
                                                    pedido.albaran_lineas
                                                        .length <= 0
                                                "
                                                @click="confirm_albaran = true"
                                                :disabled="isloading"
                                                color="primary"
                                                class="white--text mr-2"
                                                >Crear albarán</v-btn
                                            ><template
                                                v-if="pedido.albaran_lineas"
                                            >
                                                <router-link
                                                    :to="`guardar-albaran?id=${pedido.albaran_lineas[0].id_albaran}`"
                                                    v-if="
                                                        pedido.albaran_lineas
                                                            .length > 0
                                                    "
                                                >
                                                    <v-btn
                                                        @click="savePedido"
                                                        :disabled="isloading"
                                                        color="primary"
                                                        class="white--text mr-2"
                                                        >Ver albarán</v-btn
                                                    >
                                                </router-link>
                                            </template>
                                            <v-btn
                                                @click="savePedido"
                                                :disabled="isloading"
                                                color="success"
                                                class="white--text"
                                                >Actualizar</v-btn
                                            >
                                        </template>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-col>
                    </v-row>
                </v-tab-item>
                <v-tab-item>
                    <listaArchivos
                        v-on:delete_archivo="deleteArchivo"
                        :items="pedido.archivo"
                        @subir_file_64="subirArchivo64"
                    >
                    </listaArchivos>
                </v-tab-item>
            </v-tabs>

            <!-- </v-row> -->
        </v-card>

        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Editar línea
                </v-card-title>
                <v-card-text style="text-align: center">
                    <v-row>
                        <v-col cols="12">
                            <ProductosCompraSelect
                                :extra="editlinea.producto"
                                v-model="editlinea.id_producto_compra"
                                :items="productos_compra"
                                item-text="nombre"
                                item-value="id"
                                label="Producto asociado"
                            >
                            </ProductosCompraSelect>
                        </v-col>
                        <v-col cols="12" md="6">
                            <div class="spacing">
                                <v-text-field-comma
                                    v-model="editlinea.cantidad"
                                    type="number"
                                    label="Cantidad"
                                >
                                </v-text-field-comma>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6">
                            <div class="spacing">
                                <v-text-field-comma
                                    v-model="editlinea.precio"
                                    type="number"
                                    label="Precio unitario"
                                >
                                </v-text-field-comma>
                            </div>
                        </v-col>
                        <!-- <v-col cols="12" md="6">
                            <date-select
                                v-model="editlinea.fecha"
                                label="Fecha"
                            >
                            </date-select>
                        </v-col> -->
                        <v-col cols="12">
                            <div class="spacing">
                                <v-text-field
                                    v-model="editlinea.descripcion"
                                    label="Descripción"
                                >
                                </v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="12">
                            <div style="display: flex">
                                <v-text-field-comma
                                    v-if="editlinea.tipo_dcto"
                                    v-model="editlinea.dcto"
                                    type="number"
                                    label="Descuento"
                                >
                                </v-text-field-comma>
                                <v-text-field-comma
                                    v-else
                                    v-model="editlinea.dcto_per"
                                    type="number"
                                    label="Descuento"
                                >
                                </v-text-field-comma>
                                <v-btn-toggle
                                    color="primary"
                                    shaped
                                    v-model="editlinea.tipo_dcto"
                                    background-color="white"
                                >
                                    <v-btn text>
                                        <v-icon>mdi-percent</v-icon>
                                    </v-btn>
                                    <v-btn text>
                                        <v-icon>mdi-currency-eur</v-icon>
                                    </v-btn>
                                </v-btn-toggle>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>

                    <v-btn color="success" large @click="Edit()"
                        >Modificar</v-btn
                    >

                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="email_dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Enviar PDF
                </v-card-title>
                <v-card-text style="text-align: center">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="subject" label="Asunto">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea
                                v-model="pedido.texto_mail"
                                label="Cuerpo del mensaje"
                            >
                            </v-textarea>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>

                    <v-btn color="error" large @click="email_dialog = false"
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="sendEmail()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--delete dialog-->
        <v-dialog v-model="delete_dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>

                    <v-btn color="error" large @click="delete_dialog = false"
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteLinea()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="recepcionar" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2 v-if="this.pedido.fecha_real != null">
                        ¿Desea recepcionar pedido?
                    </h2>
                    <h2 v-else>¿Desea devolver el estado a pedido?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn color="error" large @click="recepcionar = false"
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="recepcionarPedido()"
                        >Aceptar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <ConfimDialog
            v-model="confirm_albaran"
            title="Confirmar albarán"
            message="Confirmar creación de albarán"
            @confirm="saveAlbaran"
        ></ConfimDialog>
    </v-container>
</template>

<script>
import listaArchivos from "../../../components/general/listaArchivos.vue";
import proveedoresSelectVue from "../../../components/general/proveedoresSelect.vue";

import { debounce } from "../../../helpers";
import moment from "moment";
import ordenesSelect from "../../../components/general/ordenesSelect.vue";
import ConfimDialog from "../../albaranes/componentes/ConfimDialog.vue";
import ProductosCompraSelect from "../../../components/general/ProductosCompraSelect.vue";
export default {
    components: {
        listaArchivos,
        proveedoresSelectVue,
        ordenesSelect,
        ConfimDialog,
        ProductosCompraSelect,
    },
    data() {
        return {
            required_val: [(v) => !!v || "El campo es requerido"],

            confirm_albaran: false,
            tab: 0,
            ordenes: [],
            productos_compra: [],
            body: null,
            subject: null,
            producto_compra: { nombre: null, id: null },
            dialog: false,
            delete_dialog: false,
            proveedores: [],
            editlinea: {
                id_producto_compra: null,
                id: null,
                descripcion: null,
                cantidad: null,
                precio: null,
                dcto: 0,
                dcto_per: 0,
                tipo_dcto: 1,
            },
            linea: {
                id_producto_compra: null,
                id: null,
                descripcion: null,
                cantidad: null,
                precio: null,
                dcto: 0,
                dcto_per: 0,
                tipo_dcto: 1,
            },
            email_dialog: false,
            headers: [
                // { text: "Código", value: "codigo", sortable: false },
                { text: "Descripción", value: "descripcion", sortable: false },
                { text: "Cantidad", value: "cantidad", sortable: false },
                { text: "Precio unidad", value: "precio", sortable: false },
                { text: "Subtotal", value: "subtotal", sortable: false },
                { text: "Descuento", value: "dcto", sortable: false },
                { text: "Total", value: "total", sortable: false },
                { text: "Acciones", value: "action", sortable: false },
            ],
            pedido: {
                lineas: [],
                manual: true,
                id_pedido: null,
            },

            recepcionar: false,
        };
    },
    watch: {
        "pedido.id_proveedor"(val) {
            this.linea.dcto = this.proveedorDcto.dcto;
            this.tipo_dcto = this.proveedorDcto.tipo_dcto;
        },
    },
    created() {
        this.$store.dispatch("getPedidos", this);
        //this.getProveedores();
        //this.getOrdenes();
        //this.getCodigos();

        if (this.$route.query.duplicate) {
            this.duplicar = this.$route.query.duplicate;
        }

        if (this.$route.query.id) {
            this.getPedido(this.$route.query.id);
        } else {
            this.$store.dispatch("getClientes", this);
        }
    },
    methods: {
        TransferirArchivos(archivos_id) {
            axios
                .post(`api/save-archivo64-pedido`, {
                    archivos: archivos_id,
                    id_presupuesto: this.presupuesto.id,
                })
                .then(
                    (res) => {
                        this.presupuesto.archivo = res.data;
                    },
                    (res) => {
                        this.$toast.error("Error al eliminar el archivo");
                    }
                );
        },
        saveAlbaran() {
            let lineas = [];
            let linea_null = false;
            this.pedido.lineas.forEach((linea) => {
                if (linea.id == null) {
                    linea_null = true;
                }
                console.log("linea", linea);
                lineas.push({
                    id_pedido: this.pedido.id,
                    id_pedido_linea: linea.id,
                    id_iva: linea?.pedido_codigo?.id_iva,
                    cantidad: linea.cantidad,
                    dcto: linea.dcto,
                    descripcion: linea.descripcion,
                    id_producto_compra: linea.id_producto_compra,
                    precio: linea.precio,
                    total: linea.total,
                });
            });
            if (linea_null) {
                this.$toast.error(
                    "Tiene líneas sin guardar, presione el botón guardar e inténtelo de nuevo"
                );
                return;
            }
            let albaran = {
                id_proveedor: this.pedido.id_proveedor,
                importe: this.pedido.total,
                observaciones: this.pedido.observaciones,
                lineas: lineas,
                especial: 0,
            };
            axios
                .post("api/save-albaran", albaran)
                .then((res) => {
                    this.$router.push("lista-albaranes");
                })
                .catch((error) => {
                    //console.log(error.response.status);
                    if (error.response.code == 400) {
                        this.$custom_error(error.response.data.error);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                });
        },

        deleteArchivo(archivo) {
            axios.get(`api/deletearchivo-pedido/${archivo.id}`).then(
                (res) => {
                    this.pedido.archivo = res.data;
                },
                (res) => {
                    this.$toast.error("Error al eliminar el archivo");
                }
            );
        },
        subirArchivo64(data) {
            let me = this;
            axios
                .post(`api/save-archivo64-pedido`, {
                    id: me.pedido.id,
                    archivo: data.data,
                    nombre: data.nombre,
                    extension: data.extension,
                })
                .then((res) => {
                    me.pedido.archivo = res.data;
                    this.$toast.sucs("Archivo guardado con éxito");
                    data.callback();
                });
        },
        /*deleteCodigo(id) {
            axios.get(`api/delete-pedido-proveedor-codigo/${id}`).then(
                (res) => {
                    this.getCodigos();
                },
                (res) => {}
            );
        },
        getCodigos() {
            let me = this;
            axios.get(`api/get-pedido-proveedor-codigos`).then(
                (res) => {
                    me.codigos = res.data;
                },
                (res) => {}
            );
        },*/
        sendEmail() {
            axios
                .post(`api/sendmail-pedidos-proveedor`, {
                    id: this.pedido.id,
                    body: this.pedido.texto_mail,
                    subject: this.subject,
                })
                .then((res) => {
                    this.email_dialog = false;
                })
                .catch((err) => {
                    this.$toast.error(err.response.data);
                });
        },
        /*saveCodigo() {
            axios.post(`api/save-pedido-proveedor-codigo`, this.codigo).then(
                (res) => {
                    this.getCodigos();
                },
                (res) => {}
            );
        },*/
        getProveedores() {
            let me = this;
            axios.get(`api/get-proveedores`).then(
                (res) => {
                    me.proveedores = res.data;
                },
                (res) => {}
            );
        },
        getDescuento(id) {
            let me = this;
            axios.get(`api/getproveedor/${id}`).then(
                (res) => {
                    me.linea.dcto = res.data.dcto ?? 0;
                    me.linea.tipo_dcto = res.data.tipo_dcto ?? 1;
                },
                (res) => {}
            );
        },

        getPedido(id) {
            let me = this;
            axios.get(`api/get-pedido-proveedor/${id}`).then(
                (res) => {
                    me.pedido = res.data;
                    me.pedido.lineas = res.data.lineas;
                    me.linea.dcto = res.data.proveedor.dcto ?? 0;
                    me.linea.tipo_dcto = res.data.proveedor.tipo_dcto ?? 1;

                    me.pedido.lineas.forEach((element) => {
                        element.total =
                            element.cantidad * element.precio - element.dcto;
                    });
                },
                (res) => {}
            );
        },
        openEditDialog(item) {
            this.editlinea = JSON.parse(JSON.stringify(item));
            this.editlinea.index = this.pedido.lineas.indexOf(item);

            console.log(item);
            this.dialog = true;
        },
        Edit() {
            let index = this.editlinea.index;
            let linea = this.getLinea(this.editlinea);
            if (linea.tipo_dcto != 1) {
                linea.dcto =
                    (linea.dcto_per / 100) * linea.cantidad * linea.precio;
            }
            //console.log(linea);
            this.pedido.lineas[index] = JSON.parse(JSON.stringify(linea));
            this.pedido.lineas = JSON.parse(JSON.stringify(this.pedido.lineas));
            this.dialog = false;
        },
        deleteLinea() {
            let index = this.pedido.lineas.indexOf(this.editlinea);

            this.pedido.lineas.splice(index, 1);
            this.delete_dialog = false;
        },
        openDeleteDialog(item) {
            this.editlinea = item;
            this.delete_dialog = true;
        },

        savePedido() {
            if (!this.$refs.pedido.validate()) return;
            axios
                .post("api/save-pedido-proveedor", {
                    pedido: this.pedido,
                    duplicar: this.duplicar,
                })
                .then((res) => {
                    this.getPedido(res.data.id);

                    //this.$router.push("lista-pedido-proveedor");
                });
        },
        recepcionarPedido() {
            axios
                .get(`api/recepcionar-pedido-proveedor/${this.pedido.id}`)
                .then(
                    (res) => {
                        this.$toast.sucs("Pedidos recepcionado con éxito");
                        this.recepcionar = false;
                        // this.getPedidos();
                    },
                    (err) => {
                        this.$custom_error("Error recepcionando el pedido");
                    }
                );
        },
        reclamar() {
            axios.get(`api/reclamar-pedido-proveedor/${this.pedido.id}`).then(
                (res) => {
                    this.$toast.sucs(res.data.success);
                    // this.recepcionar = false;
                    // this.getPedidos();
                },
                (err) => {
                    this.$custom_error(res.data.error);
                }
            );
        },
        getLinea(linea_l) {
            let linea = linea_l;

            linea.subtotal = linea.precio * linea.cantidad;

            if (linea.tipo_dcto == 0) {
                // tipo_descuento = 0 es procentaje(%) y 1 es euros(€)
                linea.dcto =
                    (linea.precio * linea.cantidad * linea.dcto_per) / 100;
                // linea.tipo_dcto = 1;
            }

            linea.total = linea.subtotal - linea.dcto;

            return JSON.parse(JSON.stringify(linea));
        },
        addLinea() {
            // this.linea.tipo_dcto = 1;
            if (this.linea.tipo_dcto != 1) {
                this.linea.dcto =
                    (this.linea.dcto_per / 100) *
                    this.linea.cantidad *
                    this.linea.precio;
            }
            this.pedido.lineas.push(this.getLinea(this.linea));
            this.linea = {
                id_producto_compra: null,
                id: null,
                descripcion: null,
                cantidad: null,
                precio: 0,
                dcto: this.proveedorDcto.dcto,
                tipo_dcto: this.proveedorDcto.tipo_dcto,
            };
            this.getDescuento(this.pedido.id_proveedor);
        },
        formatFecha(fecha) {
            let momento = moment(fecha);

            return momento.format("DD-MM-YYYY");
        },
        SearchCliente: debounce(function (val) {
            this.$store.dispatch("searchCliente", val);
        }, 500),
        endIntersect(entries, observer, isIntersecting) {
            if (isIntersecting) {
                this.$store.dispatch("getClientesNext", this);
            }
        },
        formatNumber(number) {
            if (number == null) return "null";
            return Number.parseFloat(number.toString())
                .toFixed(2)
                .replace(".", ",")
                .replace(",00", "");
        },
    },
    computed: {
        proveedorDcto() {
            if (this.pedido.id_proveedor != null) {
                const proveedor = this.proveedores.find(
                    (ele) => ele == this.pedido.id_proveedor
                );
                if (proveedor != null) {
                    return {
                        dcto: proveedor.dcto ?? 0,
                        tipo: proveedor.tipo_dcto ?? 0,
                    };
                }
            }
            return { dcto: 0, tipo: 0 };
        },
        total() {
            let total = 0;
            this.pedido.lineas.forEach((elemento) => {
                total += elemento.total;
            });
            this.pedido.total = total;
            return total;
        },
        isloading() {
            return this.$store.getters.getloading;
        },
        provincias() {
            return this.$store.getters.getprovincias;
        },
    },
};
</script>
<style>
.rowtwo {
    display: flex;
    flex-direction: row;
}

.spacing {
    padding-top: 0 !important;
}
</style>
